import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoading: false,
}
const backDropSlice = createSlice({
  name: 'backDrop',
  initialState,
  reducers: {
    showBackDrop: state => {
      state.isLoading = true
    },
    hideBackDrop: state => {
      state.isLoading = false
    },
  },
})
export const { showBackDrop, hideBackDrop } = backDropSlice.actions
export default backDropSlice.reducer
